import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "equal",
  "use": "equal-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"equal\"><g data-name=\"icon - equal sign - 12px\"><path d=\"M0 0h12v12H0z\" fill=\"none\" /><path data-name=\"↳color\" d=\"M2.485 3.541a.702.702 0 1 0 0 1.405h7.026a.702.702 0 1 0 0-1.405zm0 3.513a.702.702 0 1 0 0 1.405h7.026a.702.702 0 1 0 0-1.405z\" fill=\"#031425\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol